import { t as tr } from './i18n';
import { analyse, summary } from './analyse';
import type { Rfq } from './types';

/**
 * „De întrebat”: ce lipsește din oferta care ar câștiga și poate schimba
 * decizia. Doar câștigătorul la cost total — oricine altcineva e deja mai
 * scump; după răspuns, dacă se schimbă câștigătorul, vine rândul lui.
 */
export interface OfferQuestion {
  /** pentru om, pe scurt: „costul transportului” */
  topic: string;
  /** întrebarea, cum intră în mailul către furnizor */
  ask: string;
}

/** Întrebarea despre transportul taxat separat, fără sumă (tradusă la cerere). */
const TRANSPORT_COST = (): OfferQuestion => ({
  topic: tr('costul transportului'),
  ask: tr('Cât costă transportul până la șantier, pentru toată comanda?'),
});

export interface QuestionsFor {
  sendId: string;
  questions: OfferQuestion[];
}

/**
 * Întrebările pentru oferta câștigătoare; null dacă nu e nimic de întrebat.
 * Cu `sendId`, pentru oferta acelui furnizor: costul transportului, dacă îl
 * taxează separat fără sumă (butonul „Întreabă” din dreptul lui, în tabel).
 */
export function offerQuestions(rfq: Rfq, sendId?: string): QuestionsFor | null {
  // Cererea s-a terminat sau s-a ales deja: nu mai e nimic de comparat.
  if (rfq.closedAt || rfq.canceledAt || rfq.chosen) return null;
  const a = analyse(rfq);
  if (sendId) {
    const col = a.cols.find((c) => c.send.id === sendId);
    return col?.costUnknown ? { sendId, questions: [TRANSPORT_COST()] } : null;
  }
  const s = summary(a);
  if (!s || a.full.length < 2) return null;

  const offer = s.win.send.offer!;
  const questions: OfferQuestion[] = [];
  if (s.win.costUnknown) {
    questions.push(TRANSPORT_COST());
  } else if (
    (offer.transport ?? '') === '' &&
    a.full.some((c) => c !== s.win && (c.send.offer!.transport ?? '') !== '')
  ) {
    questions.push({
      topic: 'transportul',
      ask: tr('Prețurile includ transportul până la șantier? Dacă nu, cât costă pentru toată comanda?'),
    });
  }
  // pagina furnizorului dă termenul doar în zile, fără text
  if (!offer.delivery.trim() && offer.deliveryDays == null) {
    questions.push({ topic: tr('termenul de livrare'), ask: tr('Care este termenul de livrare?') });
  }
  return questions.length ? { sendId: s.win.send.id, questions } : null;
}
